export function initLegacyTabs(options)
{
    if (!window.jQuery || !window.TabBar) {
        return;
    }

    var $ = window.jQuery;
    var settings = options || {};
    var menuSelector = settings.menuSelector || '#tx-dftabs-tabMenu-1 > li';
    var contentSelector = settings.contentSelector || '#tx-dftabs-tabContents-1 > div';
    var $tabMenuItems = $(menuSelector);
    var $tabContents = $(contentSelector);

    document.documentElement.className = 'tx-dftabs-plugin1-hasJS ' + document.documentElement.className;

    if (!$tabMenuItems.length || !$tabContents.length) {
        return;
    }

    window.TabBar1 = new window.TabBar(
        $tabMenuItems,
        $tabContents,
        {
            autoPlayInterval: 7000,
            enableAjax: false,
            ajaxPageId: 1208,
            ajaxLanguageId: 0,
            ajaxRecords: 'pages_1213,pages_1212,pages_1211,pages_1210,pages_3236,pages_1209',
            ajaxPluginMode: 'pages',
            enableAutoPlay: false,
            enableMouseOver: false,
            classPrefix: 'tx-dftabs-',
            hashName: 'tab',
            pollingInterval: 1000,
            animationSpeed: 400,
            startIndex: 0,
            onBeforeInitialize: function () {},
            onAfterInitialize: function () {},
            onTabChange: function () {}
        }
    );
}
